import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { messages } from 'src/app/model/messages.model';

@Component({
  selector: 'app-messagelist',
  templateUrl: './messagelist.component.html',
  styleUrls: ['./messagelist.component.css']
})
export class MessagelistComponent implements OnInit {
data:any;
UserDataAny:any;
messageData:messages;



  constructor(private router:Router,private userservice:UserService, private adminservice:AdmindashboardService) { }

  ngOnInit() {
   this. getMessagelist();
  }
getMessagelist(){
  debugger;
  this.adminservice.GetMessagelist().subscribe(
    (data)=>{
      this.data=data;
      //  this.UserDataAny=data;
      //  this.messageData=this.UserDataAny;
      //  console.log("data");
      //  console.log(data);
      //  console.log("messageData");
      console.log(this.data);
    }
  )

}
}
